export class TaskManagerDataService {
    public static getTaskOverviewSelectableItems(callback: (output: any) => void, error?: () => void) {
        $.ajax({
            type: 'GET',
            url: `/api/company/task/selectable-items`,
            cache: false,
            contentType: "application/json",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            dataType: "json",
            success: callback,
            error: () => {
                error && error();
            }
        });
    }

    public static removeTask(id, callback: (output: boolean) => void, error?: () => void) {
        $.ajax({
            type: 'POST',
            url: `/api/company/task/${id}/remove`,
            cache: false,
            contentType: "application/json",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            dataType: "json",
            success: callback,
            error: () => {
                error && error();
            }
        });
    }

    public static startTask(id, callback: (output: boolean) => void, error?: () => void) {
        $.ajax({
            type: 'POST',
            url: `/api/company/task/${id}/start`,
            cache: false,
            contentType: "application/json",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            dataType: "json",
            success: callback,
            error: () => {
                error && error();
            }
        });
    }
}